import { createSlice } from "@reduxjs/toolkit";
import { isApplyModelByFundLocationChangeAction } from "store/cross-slice/utils";
export const initialState = {
    appliedModels: {},
    isToggleOn: false,
    restoredToDefault: [],
    selectedFunds: []
};
export const createFundInvestorCompositeId = (fundId, investorAccId) => (investorAccId ? `${fundId}-${investorAccId}` : fundId) || "";
export const deconstructFundInvestorCompositeId = (compositeId) => ({ fundId: compositeId.split("-")[0],
    investorAccId: compositeId.split("-")[1] });
const slice = createSlice({
    extraReducers: (builder) => {
        builder.addMatcher(isApplyModelByFundLocationChangeAction, (state) => {
            state.appliedModels = {};
            state.selectedFunds = [];
        });
    },
    initialState,
    name: "applyModelsReducers",
    reducers: {
        applyModelToSelectedFunds: (state, action) => {
            state.selectedFunds.forEach((compositeId) => {
                state.appliedModels[compositeId] = { isPredefined: action.payload.predefined, modelId: action.payload.modelId };
                const index = state.restoredToDefault.findIndex((x) => x.compositeId === compositeId);
                if (index !== -1) {
                    state.restoredToDefault.splice(index, 1);
                }
            });
            state.selectedFunds = [];
        },
        resetStateToDefault: (state) => {
            state.appliedModels = initialState.appliedModels;
            state.selectedFunds = initialState.selectedFunds;
            state.restoredToDefault = initialState.restoredToDefault;
        },
        restoreSelectedFundsToDefault: (state, action) => {
            action.payload.forEach((fund) => {
                const compositeId = createFundInvestorCompositeId(fund.fundId, fund.investorAccId);
                if (state.appliedModels[compositeId]) {
                    delete state.appliedModels[compositeId];
                }
                if (state.restoredToDefault.filter((x) => x.compositeId === compositeId).length === 0) {
                    state.restoredToDefault.push({ compositeId, defaultModelId: fund.defaultModelId });
                }
            });
            state.selectedFunds = [];
            state.restoredToDefault = [...state.restoredToDefault];
        },
        setToggle: (state, action) => {
            state.isToggleOn = action.payload.isSetOn;
        },
        updateFundSelection: (state, action) => {
            state.selectedFunds = [...action.payload.map((x) => x.compositeId)];
        }
    }
});
export const applyModelsReducers = slice.reducer;
export const { resetStateToDefault, updateFundSelection, applyModelToSelectedFunds, setToggle, restoreSelectedFundsToDefault } = slice.actions;
